// Eventy GA ramek produktów (featured-collection, ramki User.com): recommendation_show i recommendation_click.
// Kontener [data-list-name] (nazwa = tytuł sekcji), karty [data-list-item] (snippets/list-item-data.liquid).
(() => {
  if (window.trackList) return;

  function push(el, event, items) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: event, name: el.dataset.listName, ecommerce: { items: items } });
  }

  function item(el, card, index) {
    return { ...JSON.parse(card.dataset.listItem), item_list_name: el.dataset.listName, index: index };
  }

  window.trackList = (el) => {
    const cards = [...el.querySelectorAll(':scope > [data-list-item]')];
    if (!cards.length || el.hasAttribute('data-tracked')) return;
    el.setAttribute('data-tracked', '');
    // trackingOnClick z card-product dałby drugi select_item obok recommendation_click
    cards.forEach((card) => card.querySelector('.product-card__link')?.removeAttribute('onclick'));
    push(el, 'recommendation_show', cards.map((card, index) => item(el, card, index)));
    el.addEventListener('click', (event) => {
      const card = event.target.closest('.product-card__link') && event.target.closest('[data-list-item]');
      if (card) push(el, 'recommendation_click', [item(el, card, cards.indexOf(card))]);
    });
  };

  // ramki User.com śledzi user-recommendation.js, gdy ma już karty
  const init = (root) => root.querySelectorAll('[data-list-name]:not([data-user-reco])').forEach(window.trackList);
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
